import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

const Header = ({ siteTitle }) => (
  <nav className="navbar has-shadow" role="navigation" aria-label="main navigation">
    <div className="container">
      <div className="navbar-brand">
        <Link className="navbar-item" to="/" style={{
              textDecoration: `none`,
            }}>
          {/* <img src="/tajawal-en.svg" alt={siteTitle} /> */}
          <span><strong>Blog</strong></span>
        </Link>

        <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div className="navbar-menu">
        <div className="navbar-start">
          <Link className="navbar-item" to="/">About</Link>
          <Link className="navbar-item" to="/">Flights</Link>
          <Link className="navbar-item" to="/">Holidays</Link>
          <Link className="navbar-item" to="/">Hotels</Link>
        </div>
        <div className="navbar-end">
          <div className="navbar-item">
            <img 
              src="/color-facebook-48.png" 
              alt="LoremText Facebook Page" 
              style={{border: 0, height: 'auto', outline: 'none', textDecoration: 'none'}} 
              width="24" height="24"/>
          </div>
          <div className="navbar-item">
            <img 
              src="/color-twitter-48.png" 
              alt="LoremText Twitter Page" 
              style={{border: 0, height: 'auto', outline: 'none', textDecoration: 'none'}} 
              width="24" height="24"/>
          </div>
        </div>
      </div>
    </div>
  </nav>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
